<template>
  <div
    style="
      width: 100%;
      height: 100%;
      background-color: #fff;
      color: #666;
      overflow: hidden;
      font-size: large;
    "
  >
    <!-- 新增浮云容器 -->

    <div
      :style="{
        width: parseInt(form.deviceWidth) * 1.4236 + 'px',
        height: parseInt(form.deviceHeight) * 1.5 + 'px',
        'text-align': 'left',
      }"
      style="clear: both"
    >
      <div id="editorContainer" ref="editorContainer"></div>
    </div>

    <div style="width: 100%; height: 30px; margin-top: 50px; text-align: left; padding-left: 160px;">
      <el-button type="primary" @click="handleSubmit">提交</el-button>
    </div>
    <div style="width: 1px; height: 1px; overflow: hidden">
      <div
        ref="htmlContainer"
        class="html-container"
        v-html="htmlString"
        :style="{
          width: `${form.deviceWidth}px`,
          height: `${form.deviceHeight}px`,
          minWidth: '1px',
        }"
      ></div>
      <img :src="imageBase64" />{{ imageBase64 }}
    </div>
  </div>
</template>

<script>
import { teamInfoServiceAdd } from "@/public/api.js";
import WangEditor from "wangeditor";
import html2canvas from "html2canvas";

// 引入路由实例
export default {
  name: "LedUpdata",
  components: {},
  data() {
    return {
      imageBase64: null,
      editor: null,
      htmlString: null,
      form: {
        outputContent: "",
        imageBase64: "",
        deviceWidth: 160,
        deviceHeight: 80,
      },
    };
  },
  mounted() {
    // 先检查 $refs 是否存在
    if (!this.$refs.editorContainer) {
      console.error("编辑器容器不存在！");
      return;
    }
    // 再初始化实例
    this.editor = new WangEditor(this.$refs.editorContainer);
    this.editor.customConfig.height = 100; // 单位：px
    // 此时设置 menus 就不会报错了
    this.editor.customConfig.menus = [
      "bold",
      "italic",
      "fontSize",
      "fontName",
      "italic",
      "strikeThrough",
      "justify",
      "table",
    ];
    this.editor.create();
  },
  methods: {
    async handleSubmit() {
      debugger;
      // 获取编辑器原始内容（不做任何样式修改）
      this.form.outputContent = this.editor.txt.html();
      this.htmlString = this.form.outputContent;

      // 等待 DOM 更新，确保内容完全渲染
      await this.$nextTick();
      const container = this.$refs.htmlContainer;

      // 关键：不手动设置容器尺寸和样式，完全依赖原始 HTML 布局
      // （移除之前的 container.style.width/height 等强制设置）

      // 优化 html2canvas 配置，确保样式完整捕获
      const canvas = await html2canvas(container, {
        scale: 2, // 保持高清
        useCORS: true, // 允许跨域图片
        logging: false,
        // 允许捕获所有元素（包括隐藏元素，按原始样式处理）
        ignoreElements: (element) => false,
        allowTaint: true,
        // 关键配置：确保样式计算准确
        letterRendering: true, // 优化字体渲染
        useTransform: true, // 保留 CSS transform 样式
        preserveDrawingBuffer: true, // 保留绘制缓冲区，确保复杂样式正确
        // 处理可能影响样式的因素（如滚动）
        scrollX: 0,
        scrollY: 0,
        windowWidth: document.documentElement.clientWidth,
        windowHeight: document.documentElement.clientHeight,
      });

      // 生成 base64 图片（保持原始样式）
      this.imageBase64 = canvas.toDataURL("image/png");

      this.form.imageBase64 = this.imageBase64.replace(
        "data:image/png;base64,",
        ""
      );

      teamInfoServiceAdd({
        clientId: "9999999",
        message: '{"type":"led","data": ' + JSON.stringify(this.form) + "}",
      }).then((res) => {
        if (res.data.code == 200) {
          alert("提交成功");
        }
      });
    },
  },
  beforeDestroy() {
    // 销毁编辑器实例，防止内存泄漏
    if (this.editor) {
      this.editor.destroy();
      this.editor = null;
    }
  },
};
</script>
<style scoped>
:deep(.el-form-item__content) {
  /* 改用绝对定位+负偏移隐藏（脱离可视区但内容可被捕获） */
  /* 避免默认边距影响 */
  margin: 0;
  padding: 0;
  color: brown;
  text-align: left;
  line-height: 24px;
}

:deep(.w-e-text-container) {
  height: 120px !important;
  overflow: hidden;
  background-color: black;
  color: red;
}

.el-divider--horizontal {
  margin: 5px 0 !important;
}

.html-container {
  /* 改用绝对定位+负偏移隐藏（脱离可视区但内容可被捕获） */
  /* 避免默认边距影响 */
  margin: 0;
  padding: 0;
  color: brown;
  background-color: black;
  text-align: left;
}

:deep(.el-form-item__content) {
  /* 改用绝对定位+负偏移隐藏（脱离可视区但内容可被捕获） */
  /* 避免默认边距影响 */
  margin: 0;
  padding: 0;
  color: brown;
  text-align: left;
  line-height: 24px;
}
</style>